var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.domVisible,
        "custom-class": _vm.dialogClass,
        "close-on-click-modal": false,
        "lock-scroll": false,
        "before-close": _vm.closeDialog
      },
      on: {
        "update:visible": function($event) {
          _vm.domVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ]
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: { model: _vm.ruleForm, rules: _vm.rules }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "Nation" } },
                [
                  _vm.LocationIcon != null
                    ? _c("img", {
                        staticClass: "location",
                        attrs: { src: _vm.LocationIcon }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "login_ipt location_ipt",
                      class: _vm.LocationIcon != null ? "info_ipt" : "",
                      attrs: { placeholder: _vm.$t("SelectCountryRegion") },
                      on: { change: _vm.changeLocation },
                      model: {
                        value: _vm.ruleForm.memberSource,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "memberSource", $$v)
                        },
                        expression: "ruleForm.memberSource"
                      }
                    },
                    _vm._l(_vm.nationList, function(item, index) {
                      return _c(
                        "el-option",
                        {
                          key: index,
                          attrs: {
                            label:
                              _vm.$i18n.locale != "zh"
                                ? item.EnName
                                : item.ChName,
                            value: item.Code
                          }
                        },
                        [
                          _c("div", { staticClass: "locationOption" }, [
                            _c("img", { attrs: { src: item.IconUrl } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$i18n.locale != "zh"
                                    ? item.EnName
                                    : item.ChName
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "mobile" } },
                [
                  _c("span", { staticClass: "locationcode" }, [
                    _vm._v(_vm._s(_vm.ruleForm.nationCode))
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "login_ipt",
                    class: _vm.ruleForm.nationCode != "" ? "info_ipt" : "",
                    attrs: { placeholder: _vm.$t("verify.PhoneNumber1") },
                    on: {
                      input: function($event) {
                        return _vm.setInput()
                      }
                    },
                    model: {
                      value: _vm.ruleForm.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "mobile", $$v)
                      },
                      expression: "ruleForm.mobile"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "codeText" },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "login_form_item", attrs: { prop: "code" } },
                    [
                      _c("el-input", {
                        staticClass: "login_ipt codeIpt",
                        attrs: {
                          placeholder: _vm.$t("verify.VerificationCode")
                        },
                        on: {
                          input: function($event) {
                            return _vm.setInput()
                          }
                        },
                        model: {
                          value: _vm.ruleForm.code,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "code", $$v)
                          },
                          expression: "ruleForm.code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "login_btn codeBtn",
                      attrs: { disabled: _vm.isCode, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.getCode("ruleForm")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.codeText))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "password" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "login_ipt",
                      attrs: {
                        type: _vm.flagType,
                        minlength: "6",
                        maxlength: "20",
                        placeholder: _vm.$t("verify.Password")
                      },
                      on: {
                        input: function($event) {
                          return _vm.setInput("password")
                        }
                      },
                      model: {
                        value: _vm.ruleForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "password", $$v)
                        },
                        expression: "ruleForm.password"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "showing",
                        class: [_vm.flag == true ? "show" : "noshow"],
                        attrs: { slot: "suffix" },
                        on: {
                          click: function($event) {
                            return _vm.getFlag()
                          }
                        },
                        slot: "suffix"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "noError",
                      class: "lang-" + _vm.$i18n.locale
                    },
                    [_vm._v(_vm._s(_vm.$t("verify.WordCount")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "login_form_item", attrs: { prop: "nickName" } },
                [
                  _c("el-input", {
                    staticClass: "login_ipt",
                    attrs: {
                      placeholder: _vm.$t("verify.nickname"),
                      minlength: "1",
                      maxlength: "20"
                    },
                    on: {
                      input: function($event) {
                        return _vm.setInput("nickName")
                      }
                    },
                    model: {
                      value: _vm.ruleForm.nickName,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "nickName", $$v)
                      },
                      expression: "ruleForm.nickName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "login_btn",
                  attrs: { disabled: _vm.disabled, type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SignUp")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "returnLogin" }, [
                _vm._v(_vm._s(_vm.$t("verify.AlreadyAccount"))),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.godialog("login", "register")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SignIn")))]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { label: _vm.$t("RememberMe"), name: "type" },
                      model: {
                        value: _vm.checked,
                        callback: function($$v) {
                          _vm.checked = $$v
                        },
                        expression: "checked"
                      }
                    },
                    [
                      _c(
                        "i18n",
                        {
                          staticClass: "userText",
                          attrs: { path: "agreeTo", tag: "div" }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "text_blue",
                              attrs: {
                                to: { path: "/useragreement" },
                                target: "_blank"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("UserAgreement")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "text_blue",
                              attrs: {
                                to: { path: "/privacyagreement" },
                                target: "_blank"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("PrivacyPolicy")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2149eac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2149eac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/register.vue
// module id = null
// module chunks = 